import { useEffect, useState } from 'react';
import { breakpoints, type Breakpoint } from '../tokens/primitives.ts';

const mediaOf = (query: string): MediaQueryList | null =>
  typeof window === 'undefined' || typeof window.matchMedia !== 'function' ? null : window.matchMedia(query);

const subscribe = (query: string, onChange: (matches: boolean) => void): (() => void) => {
  const media = mediaOf(query);
  if (media === null) return () => undefined;
  const listener = (event: MediaQueryListEvent) => {
    onChange(event.matches);
  };
  media.addEventListener('change', listener);
  onChange(media.matches);
  return () => {
    media.removeEventListener('change', listener);
  };
};

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => mediaOf(query)?.matches ?? false);
  useEffect(() => subscribe(query, setMatches), [query]);
  return matches;
};

export const useBreakpoint = (min: Breakpoint): boolean =>
  useMediaQuery(`(min-width: ${String(breakpoints[min])}px)`);
